import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Claims = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default Claims;
